import { useState, useEffect } from "react";
import { fetchInsurances, Insurance } from "@/services/insurance-service";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";

interface InsuranceSelectProps {
  value?: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
}

export function InsuranceSelect({ value, onValueChange, placeholder = "Selecionar convênio" }: InsuranceSelectProps) {
  const [insurances, setInsurances] = useState<Insurance[]>([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    loadInsurances();
  }, []);

  const loadInsurances = async () => {
    try {
      const data = await fetchInsurances(false, false, 1, 1000);
      setInsurances(data);
    } catch (error) {
      console.error("Erro ao carregar convênios:", error);
    }
  };

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="bg-background">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="bg-popover z-50">
        <Input
          type="text"
          placeholder="Digite para buscar..."
          className="w-full px-2 py-1 border-b mb-2"
          value={filter}
          onChange={(e) => setFilter(e.target.value.toLowerCase())}
        />
        {insurances
          .filter((insurance) => insurance.name.toLowerCase().includes(filter))
          .map((insurance) => (
            <SelectItem key={insurance.id} value={insurance.id}>
              {insurance.name}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
}
